var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-card',{staticClass:"observe-module"}),_c('week-img',{staticClass:"observe-module"}),_c('satellite',{staticClass:"observe-module"}),_c('data-trend',{staticClass:"observe-module"}),_c('cover-statistics',{staticClass:"observe-module"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }